export enum ViewType {
  PARTNERS = 'partners',
  DISPUTES = 'disputes',
  INVOICES = 'invoices'
}
